import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useDetails from "../hooks/useDetails";
import { getHostelList, hostelError } from "../utils/hostel";
import { InstitutionName } from "../utils";
import moment from "moment";

export default function HostelAllocation() {
  const [params] = useSearchParams();
  const id = params.get("application");
  const [allocation, setAllocation] = useState(null);
  const [error, setError] = useState("");
  const { data: student } = useDetails();
  const navigate = useNavigate();
  useEffect(() => {
    let active = true;
    getHostelList("/hostel/applications/").then(rows => {
      const record = rows.find(row => String(row.id) === id && row.status === "APPROVED");
      if (active) {
        if (record) setAllocation(record);
        else setError("An approved allocation was not found. Return to accommodation to check your status.");
      }
    }).catch(err => { if (active) setError(hostelError(err)); });
    return () => { active = false; };
  }, [id]);
  return <>
    <div className="print-button">
      <button className="btn-danger" onClick={() => navigate("/accommodation")}>Back to accommodation</button>
      <button className="btn-primary" disabled={!allocation || !student} onClick={() => window.print()}>Print allocation slip</button>
    </div>
    {error && <p role="alert">{error}</p>}
    {!error && (!allocation || !student) && <p role="status">Loading allocation...</p>}
    {allocation && student && <div className="receipt"><div className="contents">
      <div className="receipt-header"><h2>{InstitutionName}</h2><h3>Hostel Allocation Slip</h3></div>
      <div className="receipt-body"><div className="body-info">
        {[ ["Student", `${student.surname} ${student.othername}`], ["Matriculation Number", student.matric_number],
          ["Session", student.session?.id === allocation.session ? student.session.name : allocation.session],
          ["Hostel", allocation.hostel?.name], ["Room", allocation.room?.room_number],
          ["Bed Space", allocation.bed_space?.label], ["Application ID", allocation.id],
          ["Status", allocation.status], ["Accommodation Payment", allocation.is_paid ? "Paid" : "Pending"],
          ["Approved", allocation.approved_at ? moment(allocation.approved_at).format("DD MMM YYYY, h:mm A") : "—"],
          ["Payment Deadline", allocation.payment_deadline ? moment(allocation.payment_deadline).format("DD MMM YYYY, h:mm A") : "—"]
        ].map(([label, value]) => <div key={label}><h3 className="user-details-option">{label}:</h3><h3 className="user-details-info">{value || "—"}</h3></div>)}
      </div></div>
    </div></div>}
  </>;
}
